import {getBootstrapData} from '@common/core/bootstrap-data/use-backend-bootstrap-data';

export interface LegalPages {
  privacy_policy?: string;
  terms_of_service?: string;
  pdn_consent?: string;
}

const fallbackLegalPages: Required<LegalPages> = {
  privacy_policy: '/pages/privacy-policy',
  terms_of_service: '/pages/terms-of-service',
  pdn_consent: '/pages/pdn-consent',
};

export function getLegalPages(): Required<LegalPages> {
  const pages = getBootstrapData().legal_pages;

  return {
    privacy_policy:
      pages?.privacy_policy ?? fallbackLegalPages.privacy_policy,
    terms_of_service:
      pages?.terms_of_service ?? fallbackLegalPages.terms_of_service,
    pdn_consent: pages?.pdn_consent ?? fallbackLegalPages.pdn_consent,
  };
}
